<template>
	<div>
		<sellerorderlist></sellerorderlist>
	</div>
</template>
<script>
import sellerorderlist from '@/components/sellerOrderList.vue'
export default {
	components: {
		sellerorderlist
	},
	data() {
		return {
		}
	},
	// 初始事件
	mounted: function () {
	},
	// 事件
	methods: {
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.font_input{
	line-height: 1.4;
}
.page-pagination{
	padding: 20px 10px 0;
}
.roll_history{
	padding: 20px 0;
}
.roll_history .p1{
	font-size: 20px;
	color: #000000;
	font-weight: bold;
	margin-bottom: 10px;
}
.roll_history .p2{
	margin-bottom: 40px;
	font-size: 20px;
	color: #000000;
}
.roll_history .p2 span{
	margin-right: 30px;
	margin-bottom: 20px;
}
.img_img{
	float: left;
	margin-right: 10px;
	width: 232px;
	height: 230px;
	margin-bottom: 10px;
}
.img_img:nth-child(4n){
	margin-right: 0;
}
.img_img .video{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/order/sellerList.vue